module.exports = __webpack_public_path__ + "img/flag_france.34e17258.svg";